import { languagesBP } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/useReferenceData'
import React, { useState } from 'react'

import { ETranslationScope, translationAPI } from 'onboarding/classes/services/api/TranslationAPI'
import { HPGuestLayout } from 'onboarding/components/layout/hpGuestLayout/HPGuestLayout'
import { BPTCReconfirmationBody } from 'onboarding/components/page/bpTCReconfirmation/Body'
import { LanguageProvider } from 'onboarding/context/LanguageContext'

import styles from './Page.module.scss'

const TRANSLATIONS_LOADERS = [translationAPI.fetchTranslations]

export const BPTCReconfirmationPage = () => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <LanguageProvider
      translationsLoaders={TRANSLATIONS_LOADERS}
      defaultScope={ETranslationScope.partner360Hpscoutso}
      fallbackLanguage={'en'}
    >
      <HPGuestLayout isLoading={isLoading} setIsLoading={setIsLoading} languages={languagesBP}>
        <h2 className={styles.title}>T&C Reconfirmation</h2>
        <BPTCReconfirmationBody />
      </HPGuestLayout>
    </LanguageProvider>
  )
}
